document.addEventListener('DOMContentLoaded', () => {
	const panWraps = document.querySelectorAll('.pan-wrap');

	panWraps.forEach((panWrap) => {
		const scrollArea = panWrap.querySelector<HTMLElement>('.pan-wrap__scroll');
		const indicator = panWrap.querySelector<HTMLElement>(
			'.pan-wrap__indicator',
		);

		if (!scrollArea || !indicator) return;

		indicator.addEventListener('click', () => {
			scrollArea.scrollTo({
				left: (scrollArea.scrollLeft + scrollArea.clientWidth) * 0.75,
				behavior: 'smooth',
			});
		});

		scrollArea.addEventListener('scroll', () => {
			const hasScrolled = scrollArea.scrollLeft > 50;
			indicator?.classList.toggle('pan-wrap__indicator--hidden', hasScrolled);
		});
	});
});
